export const Projectdata = [
{
    id:1,
    title: "The Exercise Hub",
    about:"An all in one web app featuring 1000+ exercises.Exercises can be filtered and fetched on the basis of target muscle, equipments used, similar positions etc with supporting easy to follow video tutorials.",
    tags: ["Reactjs", "HTML5" , "CSS3", "Javascript"],
    demo: "https://the-exercise-hub.netlify.app/",
    github: "www.github.com",
    image : "../Assets/gym.png"
},

{
    id:2,
    title: "The News Monkey",
    about:"An holistic web app that provides latest and updated news from 5 different countries and across 7 categories.News is available in local language as well.The news can be red in light and dark modes.",
    tags: ["Reactjs", "HTML5" , "CSS3", "Javascript"],
    demo: "https://the-news-monkey.netlify.app/",
    github: "www.github.com",
    image : "../Assets/news.png"
},
{
    id:3,
    title: "Youtube Buddy",
    about:"A youtube video videos management app.The app has a secure authentication.You can save your videos here.Sort them in categories.The app provides the functionality of note taking.The app also suggests videos based upon your saved videos.",
    tags: ["Reactjs", "HTML5" , "CSS3", "Javascript","authentication"],
    demo: "https://youtubebuddy.netlify.app/",
    github: "www.github.com",
    image : "../Assets/youtubebuddy.png"
}
,
{
    id:4,
    title: "Moneymate",
    about:"An all in one money management app that allows you to adda  budget, add multiple salary and expense sources.The app help the user to visualize their spendings with beautiful graph and pie charts.Moreover, the app also keep a check on spending percentage. ",
    tags: ["Reactjs", "HTML5" , "CSS3", "Javascript","authentication", "chart.js"],
    demo: "https://moneymate-app.netlify.app/",
    github: "www.github.com",
    image : "../Assets/moneymate.png"
}
,
{
    id:5,
    title: "Beatwave",
    about:"Beatwave is a modern responsive ecommerce webapp with modern features like searching, filtering.User can save the products, add them to cart, add coupons and place an order.The app also allows custom address management.All managemented by a backend.The data is secured with authentication. ",
    tags: ["Reactjs", "HTML5" , "CSS3", "Javascript","authentication", "mock backend"],
    demo: "https://beatwave.vercel.app/",
    github: "www.github.com",
    image : "../Assets/beatwave.png"
},
{
    id:6,
    title: "chatmate",
    about:"Chatmate is a social media platform.The app allows the user to post images/gif/videos.The user can like, unlike.bookmark and comment on the post.App provides the functionality to update the user information and can follow unfollow other users.The data is secured with authentication",
    tags: ["Reactjs", "HTML5" , "CSS3", "Javascript","authentication", "mock backend"],
    demo: "https://beatwave.vercel.app/",
    github: "www.github.com",
    image : "../Assets/chatmate.png"
}
]